<template>

  <div class="w-full">
    <div class="flex">

      <div class="w-1/4" v-for="(step,index) of flow">
        <div class="relative mb-2">

          <div v-if="current_step> index && index > 0"
               class="absolute flex align-center items-center align-middle content-center"
               style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
            <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
              <div class="w-0 bg-green-300 py-1 rounded" style="width: 100%;"></div>
            </div>
          </div>
          <div v-else-if="index > 0"
               class="absolute flex align-center items-center align-middle content-center"
               style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
            <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
              <div class="w-0 bg-gray-200 py-1 rounded" style="width: 100%;"></div>
            </div>
          </div>

          <div :class="current_step> index ? 'border-green-300' : 'border-gray-300'"
               class="cursor-pointer w-8 h-8 mx-auto  justify-center border-2 rounded-full text-lg text-white flex items-center">
            <a-tooltip placement="top">
              <template #title>
                <span>{{ step.desc }}</span>
              </template>
              <span class="text-center" :class="current_step> index ? 'text-green-600' : 'text-gray-600'">
              <span class="py-1 px-1 font-bold">{{ index + 1 }}</span>
          </span>
            </a-tooltip>

          </div>
        </div>
        <a-tooltip placement="top">
          <template #title>
            <span>{{ step.desc }}</span>
          </template>
          <div class="text-xs font-semibold text-center md:text-base">{{ step.name }}</div>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {}
  },
  props: ['flow', 'current_step'],
};
</script>